// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__DtE5Y","containerWrapper":"Sidebar_containerWrapper__kxhwl","titleContainer":"Sidebar_titleContainer__VqYq2","title":"Sidebar_title__OJiSy"};